import { getMyAvailabilityConstants } from 'src/redux/actions/constant';

const {
  GET_MY_AVAILABILITY_REQUEST,
  CREATE_PTO_REQUEST_REQUEST,
  GET_ALL_PTO_REQUEST,
  REMOVE_PTO_REQ_REQUEST,
  REMOVE_PTO_REQ_RESET,
  CREATE_PTO_RESET_REQUEST,
  EDIT_MY_AVAILABILITY_RESET,
  EDIT_MY_AVAILABILITY_REQUEST,
  GET_LIST_OF_THERAPIST_AVA_REQUEST,
  GET_LIST_OF_THERAPIST_AVA_RESET,
} = getMyAvailabilityConstants;
interface PtoRequestType {
  description: string;
  allDay: boolean;
  startDate: string;
  endDate: string;
}

export const getMyAvailabilityAction = (payload: any) => {
  return {
    type: GET_MY_AVAILABILITY_REQUEST,
    payload,
  };
};

export const getListOfTherapistAvailability = () => {
  return {
    type: GET_LIST_OF_THERAPIST_AVA_REQUEST,
  };
};

export const resetListOfTherapistAvailability = () => {
  return {
    type: GET_LIST_OF_THERAPIST_AVA_RESET,
  };
};

export const createPtoRequestAction = (payload: PtoRequestType, providerId: string) => {
  return {
    type: CREATE_PTO_REQUEST_REQUEST,
    payload,
    providerId,
  };
};

export const getAllPtoRequestAction = (providerId: string) => {
  return {
    type: GET_ALL_PTO_REQUEST,
    providerId,
  };
};

export const removePtoRequest = (providerId: string) => {
  return {
    type: REMOVE_PTO_REQ_REQUEST,
    providerId,
  };
};

export const resetPtoRequest = () => {
  return {
    type: CREATE_PTO_RESET_REQUEST,
  };
};

export const resetRemovePtoRequest = () => {
  return {
    type: REMOVE_PTO_REQ_RESET,
  };
};

export const editMyAvailabilityAction = (payload: any) => {
  return {
    type: EDIT_MY_AVAILABILITY_REQUEST,
    payload,
  };
};

export const resetEditMyAvailability = () => {
  return {
    type: EDIT_MY_AVAILABILITY_RESET,
  };
};
